import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { loadAnalytics, hasAnalyticsConsent } from "@/lib/analytics";

const KEY = "umi-cookie-consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      setVisible(true);
    } else if (hasAnalyticsConsent()) {
      loadAnalytics();
    }
    const reopen = () => setVisible(true);
    window.addEventListener("umi:open-cookie-settings", reopen);
    return () => window.removeEventListener("umi:open-cookie-settings", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
    if (value === "accepted") loadAnalytics();
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-[60] px-4 pb-4 sm:px-6">
      <div className="max-w-3xl mx-auto rounded-2xl bg-[#0B2545] text-white shadow-2xl border border-white/10 p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex w-10 h-10 rounded-xl bg-white/10 items-center justify-center shrink-0">
            <Cookie size={20} className="text-[#17B8A6]" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <p className="font-heading font-semibold text-base">A quick word on cookies</p>
            <p className="mt-1 text-sm text-slate-300 leading-relaxed">
              We use essential cookies to keep the site working, and we'd like to use analytics cookies (Google Analytics) to understand how visitors use the site so we can improve it. Analytics only load if you say yes. Read our{" "}
              <Link to="/cookie-policy" className="underline text-[#17B8A6] hover:text-white transition-colors duration-150">Cookie Policy</Link>.
            </p>
            <div className="mt-4 flex flex-col sm:flex-row gap-3">
              <button onClick={() => choose("accepted")} data-testid="cookie-accept"
                className="bg-[#17B8A6] hover:bg-[#0D9488] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors duration-200">
                Accept analytics cookies
              </button>
              <button onClick={() => choose("declined")} data-testid="cookie-decline"
                className="border border-white/25 hover:bg-white/10 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors duration-200">
                Essential cookies only
              </button>
            </div>
          </div>
          <button onClick={() => choose("declined")} data-testid="cookie-dismiss" aria-label="Dismiss cookie banner"
            className="shrink-0 p-1.5 text-slate-400 hover:text-white transition-colors duration-150">
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
